import {PlayClass} from "../../models/class-structure/generic/PlayClass";
import {MultipleClassController} from "../generic/MultipleClassController";
import {SingleClassController} from "../generic/SingleClassController";

export class PianoSectionClassController extends MultipleClassController {

  constructor(playClass: PlayClass, parentClass: PlayClass = playClass) { // Using parentClass for single section part class
    const orderedClasControllers = [] as SingleClassController[];
    let currentClassIndex = 0;

    const leftHandClass = playClass.containedClasses.find((containedClass) => containedClass.type === 'PIANO_LEFT');
    const rightHandClass = playClass.containedClasses.find((containedClass) => containedClass.type === 'PIANO_RIGHT');

    if (leftHandClass) {
      orderedClasControllers.push(new SingleClassController(leftHandClass));
      if (leftHandClass.progress.isFinished) {
        currentClassIndex = 1;
      }
    }
    if (rightHandClass) {
      orderedClasControllers.push(new SingleClassController(rightHandClass));
      if (rightHandClass.progress.isFinished) {
        currentClassIndex = 2;
      }
    }
    orderedClasControllers.push(new SingleClassController(playClass));

    super(parentClass, orderedClasControllers, true, currentClassIndex);
  }
}
